import { render, staticRenderFns } from "./self-assessment-starting-page.vue?vue&type=template&id=695992e0&scoped=true&"
import script from "./self-assessment-starting-page.vue?vue&type=script&lang=ts&"
export * from "./self-assessment-starting-page.vue?vue&type=script&lang=ts&"
import style0 from "./self-assessment-starting-page.vue?vue&type=style&index=0&id=695992e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695992e0",
  null
  
)

export default component.exports